var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40831",
    "data-name": "Group 40831",
    transform: "translate(20434 17185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15523",
    "data-name": "Rectangle 15523",
    width: 32,
    height: 32,
    transform: "translate(-20434 -17185)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "save-instagram_1_",
    "data-name": "save-instagram (1)",
    transform: "translate(-20428.486 -17183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36986",
    "data-name": "Path 36986",
    d: "M82.66,0H66.845a2.577,2.577,0,0,0-2.578,2.578V25.964A2.039,2.039,0,0,0,66.3,28a2.116,2.116,0,0,0,1.5-.621l6.028-6.027a1.3,1.3,0,0,1,1.837,0L81.7,27.379A2.116,2.116,0,0,0,83.2,28a2.039,2.039,0,0,0,2.037-2.036V2.578A2.577,2.577,0,0,0,82.66,0Z",
    transform: "translate(-64.267 0)",
    fill: "#d1131d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36987",
    "data-name": "Path 36987",
    d: "M263.908,0H256V20.971a1.3,1.3,0,0,1,.919.381l6.029,6.027a2.116,2.116,0,0,0,1.5.621,2.039,2.039,0,0,0,2.037-2.036V2.578A2.577,2.577,0,0,0,263.908,0Z",
    transform: "translate(-245.515 0)",
    fill: "#74163b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAvatar);
export default __webpack_public_path__ + "static/media/question-avatar.8675afe2f2764bbc8330da1f962c920f.svg";
export { ForwardRef as ReactComponent };